<template>
  <b-container>
    <b-card class="vdist">
      <h3>postęp prac</h3>
      <b-row v-for="up in userProgress" :key="up.user.id">
        <b-col cols="2" md="2">{{ up.user.id }}</b-col>
        <b-col cols="10" md="4">{{ up.user.login }}</b-col>
        <b-col cols="12" md="6">
          <Progress :done="up.stats.progress.done" :todo="up.stats.progress.todo"
                    :rest="up.stats.progress.rest"></Progress>
        </b-col>
      </b-row>
      <b-badge variant="success">zrobione</b-badge>&nbsp;
      <b-badge variant="warning">do zrobienia</b-badge>&nbsp;
      <b-badge variant="primary">nie zlecone</b-badge> &nbsp;
    </b-card>
    <b-card class="vdist black-text">
      <h3>czas adnotacji (s)
        <b-badge id="times_badge">?</b-badge>
      </h3>
      <apexchart :series="times" :options="heatmapConf" type="heatmap" :height="30*times.length+70"></apexchart>
      <b-tooltip target="times_badge" triggers="hover">
        Średni całkowity czas nie jest równy sumie średnich dla kategorii, ponieważ w skład średniego czasu całkowitego
        wchodzi zmienna liczba kategorii.
      </b-tooltip>
    </b-card>
    <b-card class="vdist">
      <h3>ilość par oetykietowanych X razy
        <b-badge id="tagged_badge">?</b-badge>
      </h3>
      <apexchart :series="tagged" :options="heatmapConf" type="heatmap" height="100"></apexchart>
      <b-tooltip target="tagged_badge" triggers="hover">
        Na osi OX zaznaczone są ilości głosów a na polu wykresu za pomocą koloru i wartości ilość par oetykietowanych
        tyleż razy.
      </b-tooltip>
    </b-card>
    <b-card class="vdist">
      <h3>Rozkład wartości głosów</h3>
      <Distribution :values="voteDist"></Distribution>
    </b-card>
    <b-card class="vdist">
      <h3>Zrzut głosów</h3>
      <b-button @click="downloadVotes">pobierz</b-button>
    </b-card>
  </b-container>

</template>

<script>

import {api} from '@/utils'
import Progress from "@/components/Progress";
import Distribution from "@/components/Distribution";

export default {
  name: 'statsPage',
  components: {Distribution, Progress},
  props: ["axios"],
  data: function () {
    return {
      userProgress: [],
      userTimes: [],
      pairTagged: [],
      voteDist: {},
      heatmapConf: {
        dataLabels: {
          enabled: true,
          style: {colors: ['#000000'] },
        },
        chart: {foreColor: '#ffffff'},
      }
    }
  },
  created() {
    this.loadStats();
  },
  computed: {
    times() {
      return this.userTimes.map(ut => ({
        name: ut.user.login,
        data: Object.keys(ut.times.values).map(k => ({x: k, y: Math.round(ut.times.values[k]/100)/10}))
      }))
    },
    tagged() {
      return [{
        name: "",
        data: this.pairTagged.map(pt => ({x: String(pt[0]), y: pt[1]}))
      }]
    }
  },
  methods: {
    api(url){
      return api(url)
    },
    loadStats() {
      this.axios.get(api("stats/progress"))
          .then(resp => {
            this.userProgress = resp.data
          })
      this.axios.get(api("stats/times"))
          .then(resp => {
            this.userTimes = resp.data
          })
      this.axios.get(api("stats/tagged"))
          .then(resp => {
            this.pairTagged = resp.data
          })
      this.axios.get(api("stats/vote_dist"))
          .then(resp => {
            this.voteDist = resp.data.distribution;
          })
    },
    downloadVotes(){
      this.axios.request({url: api("dump"), method:"GET",  responseType: 'blob'})
      .then(({ data }) => {
        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', 'votes.csv'); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
    }


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
